<div *ngIf="!fieldOptions.parentClassificationFieldKey"
      class="form-group">
    <label>{{ 'Catalogue values:' | translate }} </label>
    <select class="form-control"
            name="classificationType"
            [(ngModel)]="fieldOptions.classificationType"
            (change)="mapClassificationFields();">
    <option *ngFor="let classification of classificationsList" value="{{classification.id}}"
            [selected]="fieldOptions.classificationType === classification.id">{{classification.name}}
    </option>
  </select>

</div>

<div class="form-group"
     *ngIf="fields">
    <label>{{ 'Parent Catalogues list:' | translate }} </label>
    <select class="form-control"
            name="parentClassificationFieldKey"
            [(ngModel)]="fieldOptions.parentClassificationFieldKey"
            (change)="fieldOptions.classificationType = ''">
    <option value="">None</option>
    <option *ngFor="let parentClassification of classificationFields" value="{{parentClassification.key}}"
            [selected]="fieldOptions.parentClassificationFieldKey === parentClassification.key">
      {{parentClassification.label}}
    </option>
  </select>
</div>